import { render, staticRenderFns } from "./SmsPreview.vue?vue&type=template&id=bc34e224"
import script from "./SmsPreview.vue?vue&type=script&lang=js"
export * from "./SmsPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports